import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {
    IEditElectiveSubjectStudent,
    IElectiveCreate,
    IElectivePayload,
    IElectiveSubjectBlock,
    IElectiveSubjectGroup,
    IElectiveSubjectStudent
} from "../types";
import {
    deletedElective,
    deletedRestoreElective,
    setElective,
    setElectiveStudent, setElectiveStudentGroup,
    setRestoreElective,

} from "./electiveSlice";


const GetElective = createAsyncThunk(
    "get/elective",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/elective-subject");
            dispatch(setElective(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const SetElective = createAsyncThunk(
    "create/elective",
    async ( data : IElectiveCreate,{rejectWithValue}) => {
        try {
            const response = await request.post("/elective-subject", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteElective = createAsyncThunk(
    "delete/elective",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/elective-subject/${id}`);
            dispatch(deletedElective(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditElective = createAsyncThunk(
    "edit/elective",
    async ( data : IElectivePayload, { rejectWithValue }) => {
        try {
            const response = await request.put(`/elective-subject/${data.id}`, data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteElective = createAsyncThunk(
    "get/delete/elective",
    async (_, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/elective-subject/deleted-items`);
            dispatch(setRestoreElective(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteElective = createAsyncThunk(
    "restore/delete/elective",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.post(`/elective-subject/restore/${id}`);
            dispatch(deletedRestoreElective(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);



const GetItemElective = createAsyncThunk(
    "get/item/elective",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/elective-subject/${id}`)
            dispatch(setElectiveStudent(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const ElectiveSubjectGroup = createAsyncThunk(
    "elective-subject-group",
    async (data:IElectiveSubjectGroup,{rejectWithValue})=>{
        const {id,value} = data
        try {
            const response = await request.put(`/elective-subject-group/${id}`,{
                value:value,
            })
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

const ElectiveSubjectBlock= createAsyncThunk(
    "elective-subject-block",
    async (data:IElectiveSubjectBlock,{rejectWithValue})=>{
        const {id,studentCount} = data
        try {
            const response = await request.put(`/elective-subject-block/${id}`,{
                student_count:studentCount,
            })
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

const ElectiveSubjectStudent= createAsyncThunk(
    "elective-subject-student",
    async (data:IElectiveSubjectStudent,{rejectWithValue})=>{
        try {
            const response = await request.post("elective-subject-student",data)
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)




const GetElectiveSubjectStudent= createAsyncThunk(
    "get/elective-subject-student",
    async (elective_subject_id:number,{rejectWithValue,dispatch})=>{
        try {
            const response = await request.get("elective-subject-student",{
                params:{elective_subject_id}
            })
            dispatch(setElectiveStudentGroup(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

const EditElectiveSubjectStudent= createAsyncThunk(
    "edit/elective-subject-student",
    async (data:IEditElectiveSubjectStudent,{rejectWithValue})=>{
        try {
            const response = await request.put(`elective-subject-student/${data.id}`,data)
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)
const DeleteElectiveSubjectStudent = createAsyncThunk(
    "delete/elective-subject-student",
    async (ids: number[], { rejectWithValue }) => {
        try {
            const response = await request.delete("elective-subject-student", {
                data: { ids },
            });
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(
                typedError.response?.data?.message || "unexpected_fail"
            );
        }
    }
);



export{
    GetElective,
    SetElective,
    DeleteElective,
    EditElective,
    RestoreDeleteElective,
    GetDeleteElective,
    GetItemElective,
    ElectiveSubjectGroup,
    ElectiveSubjectBlock,
    ElectiveSubjectStudent,
    GetElectiveSubjectStudent,
    EditElectiveSubjectStudent,
    DeleteElectiveSubjectStudent

}
